import { faBrowser } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card } from 'reactstrap';

export default function BrowserNotSupported() {
  return (
    <div
      className="d-flex align-items-center justify-content-center w-100"
      style={{ height: '100vh' }}
    >
      <Card className="d-inline-block m-3 p-4 p-sm-5 shadow-sm text-large">
        <div
          className="w-100 mx-auto mb-3 text-center fa-layers fa-fw"
          style={{ height: 128 }}
        >
          <FontAwesomeIcon
            icon={faBrowser}
            size="8x"
            className="text-gray-light"
          />
          <FontAwesomeIcon icon={faTimes} size="4x" className="text-red" />
        </div>
        <h1 tabIndex={0} className="mb-4">
          This browser is not supported.
        </h1>
        <p>Please use one of the following browsers:</p>
        <ul className="mb-0">
          <li>Firefox</li>
          <li>Chrome</li>
          <li>Microsoft Edge</li>
          <li>Safari</li>
        </ul>
      </Card>
    </div>
  );
}
